export default [
    {
        conditions: [1, 4],
        heading: 'Investičný dotazník',
        questions: [
            {
                id: 1,
                text: 'Vzdelanie:',
                value: {},
                options: [
                    {
                        value: {points: 2, text: 'Vysokoškolské'}
                    },
                    {
                        value: {points: 0, text: 'Stredoškolské'},
                    },
                    {
                        value: {points: -2, text: 'Základné'},
                    }
                ]
            },
            {
                id: 2,
                text: 'Je Vaše najvyšie dosiahnuté vzdelanie ekonomického zamerania?',
                value: {},
                options: [
                    {
                        value: {points: 3, text: "áno"}
                    },
                    {
                        value: {points: 0, text: "nie"}
                    }
                ]
            },
            {
                id: 3,
                text: 'Váš hlavný zdroj príjmu:',
                input: {
                    label: 'Oblasť',
                    type: 'text',
                    placeholder: "napr. lekár",
                    required: true,
                    hidden: true,
                    value: ''
                },
                value: [],
                options: [
                    {
                        value: {points: 1, text: "Zamestnanec", showInput: true}
                    },
                    {
                        value: {points: 1, text: "SZČO", showInput: true}
                    },
                    {
                        value: {points: 1, text: "Podnikateľ", showInput: true}
                    },
                    {
                        value: {points: -1, text: "Študent"}
                    },
                    {
                        value: {points: -1, text: "Dôchodca"}
                    },
                    {
                        value: {points: -3, text: "Nezamestnaný"}
                    }
                ]
            },
            {
                id: 4,
                text: 'Ste Vy alebo Vám blízka osoba politicky exponovanou osobou?',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "áno"}
                    },
                    {
                        value: {points: 0, text: "nie"}
                    }
                ]
            },
            {
                id: 5,
                text: 'Váš investičný zámer',
                value: {},
                options: [
                    {
                        value: {points: 2, text: "Zhodnotenie majetku"}
                    },
                    {
                        value: {points: 0, text: "Ochrana kapitálu"}
                    },
                    {
                        value: {points: 2, text: "Pravidelné sporenie "}
                    }
                ]
            },
            {
                id: 6,
                text: 'Obdobie na ktoré chcem investovať:',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "1 až 3 roky"}
                    },
                    {
                        value: {points: 3, text: "3 až 5 rokov"}
                    },
                    {
                        value: {points: 5, text: "viac ako 5 rokov"}
                    }
                ]
            },
            {
                id: 7,
                text: 'Aká je miera rizika, ktorú ste pri investovaní ochotný akceptovať?',
                value: {},
                input: null,
                options: [
                    {
                        value: {points: 0, text: "nízka"}
                    },
                    {
                        value: {points: 1, text: "stredná"}
                    },
                    {
                        value: {points: 3, text: "vysoká"}
                    }
                ]
            },
            {
                id: 8,
                text: 'Aký výnos očakávate od Vašej investície?',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "nízky"}
                    },
                    {
                        value: {points: 1, text: "stredný"}
                    },
                    {
                        value: {points: 3, text: "vysoký"}
                    }
                ]
            },
            {
                id: 9,
                text: 'Ak by hodnota Vašej dlhodobej investície klesla o 20%?',
                values: {},
                options: [
                    {
                        value: {points: -2, text: "svoju investíciu rýchlo predám aby som zabránil vyššej strate"}
                    },
                    {
                        value: {points: 0, text: "počkám na ďalší vývoj a ak nedôjde ku zmene investíciu predám"}
                    },
                    {
                        value: {points: 3, text: "ostanem pokojný a budem sledovať ďalší vývoj"}
                    }
                ]
            },
            {
                id: 10,
                text: 'Strata plánovanej investície by:',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "Nemala vplyv na môj životný štandard"}
                    },
                    {
                        value: {points: -1, text: "Znížila životný štandard"}
                    },
                    {
                        value: {points: -3, text: "Znamenala existečné problémy"}
                    }
                ]
            },
            {
                id: 11,
                text: 'Investované peniaze sú:',
                value: {},
                options: [
                    {
                        value: {points: 0, text: "Môj vlastný kapitál"}
                    },
                    {
                        value: {points: -8, text: "Peniaze získané z pôžičky alebo úveru"}
                    }
                ]
            },
            {
                id: 12,
                text: 'Akú sumu viete ročne odložiť ako úspory:',
                value: {},
                options: [
                    {
                        value: {points: 6, text: "Viac ako 10 000 EUR"}
                    },
                    {
                        value: {points: 1, text: "Viac ako 900 EUR"}
                    },
                    {
                        value: {points: 0, text: "Menej"}
                    }
                ],
            },
            {
                id: 13,
                multiple: true,
                text: 'Aké druhy cenných papierov poznáte a rozumiete ich hlavným charakteristikám:',
                value: [],
                options: [
                    {
                        value: {points: 1, text: "fondy (cenné papiere kolektívneho investovania)"}
                    },
                    {
                        value: {points: 2, text: "akcie a ETF"}
                    },
                    {
                        value: {points: 1, text: "dlhopisy a zmenky"}
                    },
                    {
                        value: {points: 0, text: "nepoznám"}
                    }
                ],
            }
        ]
    }
]
